import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const infoOverview: AppRouteModule = {
  path: '/home',
  name: 'Home',
  component: LAYOUT,
  redirect: '/home/index',
  meta: {
    orderNo: 1,
    icon: 'tdesign:bulletpoint',
    title: t('routes.nurse.infoOverview'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'HomeIndex',
      component: () => import('/@/views/nurse/info-overview/index.vue'),
      meta: {
        icon: 'tdesign:bulletpoint',
        title: t('routes.nurse.infoOverview'),
        hideMenu: true,
      },
    },
  ],
};

export default infoOverview;
